import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { Router } from '@angular/router';
import { HandlerService } from '../handler.service';
import { AuthService } from '../auth.service';
import { AppComponent } from '../app.component';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { DomSanitizer } from '@angular/platform-browser';
import { Platform } from '@angular/cdk/platform';

@Component({
  selector: 'app-awards',
  templateUrl: './awards.component.html',
  styleUrls: ['./awards.component.scss'],
})
export class AwardsComponent  {

  images = [];
  blob; 
  src;
  id;
  url;
  name;
  loader:boolean = false;
  fileType; 
  i=0;
  docs:any;
  len;
  constructor(public service: ApiService,
    public router: Router,
    public handler: HandlerService,
    public auth: AuthService,
    public app: AppComponent,
    public sanitizer: DomSanitizer,
    public bottomSheet: MatBottomSheet,
     public santinzer: DomSanitizer,
      public platform: Platform) { }

      ionViewWillEnter(){
        this.url = window.location.href;
        this.id = this.url.split('/').pop();
      }


      handleFile(files) {
        this.loader=true;
         this.docs=files;
         this.len=files.length-1;
         this.blob = files[this.i];
         this.name = files[this.i].name;
         if (files.item(this.i).type == 'video/mp4')
         this.fileType = false;
         else
         this.fileType=true;
         this.src=this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(this.blob));
         this.images.push({src:this.src,name:this.name,desc:this.name,blob:this.blob,type:this.fileType})
         if(this.i>=this.len){
          this.i=0;
          this.loader=false;
        }else{
            this.i++;
            this.handleFile(this.docs);
          }
     }

     saveData(){
       var userId=localStorage.getItem('currentUserId');
       var id = localStorage.getItem('organizationId');
       this.images.map(res => {
          this.service.uploadDoc(res.blob, res.name, res.name,id,userId).subscribe(res => {
            this.handler.res('Posted Succsessfully!!');
          }, err => {
            this.handler.err(err);
            this.loader = false;
          })
      })
     }
   
    
      deleteFile(i){
        this.images.splice(i, 1);
      }
    
      ionViewWillLeave(){
        this.images=[]
      }

      back(){
        this.router.navigate(['vendorProfile/',+ this.id ])
      }
     
      openPdf(){
       
      }
}
